import { FetchInterceptor } from "src/app/helpers/Index";
import { LoginDetails, RefreshAccessToken } from "src/app/interfaces/Index";

const endpoint = "Auth";
export const AuthService = {
	endpoint,
	login: async (loginDetails: LoginDetails, group: string) => await FetchInterceptor(`${process.env.REACT_APP_SERVER_APIURL}/${endpoint}/GetToken/${group}`, {body: JSON.stringify(loginDetails), headers: {"Content-Type": "application/json"}, method: "POST"}),
	refreshToken: async (refreshAccessToken: RefreshAccessToken) => await FetchInterceptor(`${process.env.REACT_APP_SERVER_APIURL}/${endpoint}/RefreshToken`, {body: JSON.stringify(refreshAccessToken), headers: {"Content-Type": "application/json"}, method: "POST"})
}